import { rand, randWord } from '@ngneat/falso';
import {
  DEFAULT_RECALL_PERIOD_IN_MONTHS,
  IBrand,
  IBrandSettings,
  ISchedulingEventReason,
  RECALL_TRACK_LABELS,
  RecallTrack,
} from '@principle-theorem/principle-core/interfaces';
import {
  BaseFirestoreMock,
  DocumentReference,
  MockBaseFirestore,
  MockGenerator,
  Properties,
  TIMEZONES,
} from '@principle-theorem/shared';
import { v4 as uuid } from 'uuid';

export class BrandMock
  extends BaseFirestoreMock<Properties<IBrand>>
  implements Properties<IBrand>
{
  get name(): string {
    return randWord();
  }

  get slug(): string {
    return uuid();
  }

  get settings(): IBrandSettings {
    return {
      timezone: rand(TIMEZONES),
      recalls: {
        periodInMonths: DEFAULT_RECALL_PERIOD_IN_MONTHS,
        treatmentRefs: [],
        label: RECALL_TRACK_LABELS[RecallTrack.Primary],
      },
    };
  }

  get defaultSchedulingEventReasonOrder(): DocumentReference<ISchedulingEventReason>[] {
    return [];
  }

  get logoUrl(): string {
    return '';
  }
}

export function MockBrandWithSecondaryRecall(): IBrand {
  const brand = MockGenerator.generate(BrandMock);
  return {
    ...MockBaseFirestore(),
    name: brand.name,
    slug: brand.slug,
    settings: {
      ...brand.settings,
      secondaryRecalls: {
        periodInMonths: DEFAULT_RECALL_PERIOD_IN_MONTHS,
        treatmentRefs: [],
        label: RECALL_TRACK_LABELS[RecallTrack.Secondary],
      },
    },
    defaultSchedulingEventReasonOrder: brand.defaultSchedulingEventReasonOrder,
    logoUrl: brand.logoUrl,
  };
}
